import { LegacyRef, useRef, useState } from 'react';
import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import Modal from '~/components/Modal';
import ListingRateForm from '~/components/ListingRateForm';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

export default function Report() {
  const { t } = useTranslation('app');
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const submitBtnRef = useRef<HTMLButtonElement | null>(null);

  return (
    <Modal
      modalKey="reportModal"
      title={t('reportModalTitle')}
      Footer={
        <Button
          size="medium"
          ariaLabel="listing-rating-submit"
          variant="primary"
          className="flex-1 w-full "
          type="button"
          isLoading={isLoading}
          onClick={() => submitBtnRef?.current?.click()}
        >
          <span className="text-link">{t('send')}</span>
        </Button>
      }
    >
      <div className="flex h-full w-full">
        <ListingRateForm
          submitBtnRef={submitBtnRef as LegacyRef<HTMLButtonElement>}
          onSuccess={() => {
            dispatch(closeModal('reportModal'));
            setIsLoading(false);
          }}
          onSubmit={() => {
            setIsLoading(true);
          }}
        />
      </div>
    </Modal>
  );
}
